import { render, staticRenderFns } from "./actionVideo.vue?vue&type=template&id=3cf2f5df"
import script from "./actionVideo.vue?vue&type=script&lang=js"
export * from "./actionVideo.vue?vue&type=script&lang=js"
import style0 from "./actionVideo.vue?vue&type=style&index=0&id=3cf2f5df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports